export default "__VITE_ASSET__CWBx0YBE__"